import { Box } from '@mui/system';
import { createFileRoute } from '@tanstack/react-router';

function RouteComponent() {
  return <Box>Hier werden Sie demnächst Prüfroutinen finden</Box>;
}

export const Route = createFileRoute('/_authenticated/_management/administration/pruefroutinen/')({
  component: RouteComponent,
});
